/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, number: NonNullable<unknown> }} Shop_Shipped_With_TrackingInputs */

const en_shop_shipped_with_tracking = /** @type {(inputs: Shop_Shipped_With_TrackingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sent ${i?.date} · tracking ${i?.number}`)
};

const pl_shop_shipped_with_tracking = /** @type {(inputs: Shop_Shipped_With_TrackingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wysłano ${i?.date} · przesyłka ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Sent {date} · tracking {number}" |
*
* @param {Shop_Shipped_With_TrackingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_shipped_with_tracking = /** @type {((inputs: Shop_Shipped_With_TrackingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Shipped_With_TrackingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_shipped_with_tracking(inputs)
	return en_shop_shipped_with_tracking(inputs)
});